import { styled } from "@mui/material/styles";
import { AppBar, Toolbar, Typography } from "@mui/material";

export const AppBarWrapper = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  padding: 0,
}));

export const ToolbarWrapper = styled(Toolbar)(() => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
}));

export const OrganizationTypographyWrapper = styled(Typography)(() => ({
  display: "flex",
  alignItems: "center",
  "& img": {
    height: 40,
    marginRight: 10,
  },
}));

export const UserContainerWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  marginRight: 24,
}));
